import { EMPTY_VALUE_PLACEHOLDER } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { formatWeeklyValue } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/utils/prospect-value-utils';
import type {
  RepViewProspectQueryRow,
  RepViewProspectRowData,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

export function transformToRepViewProspectRowData(
  rows: RepViewProspectQueryRow[],
): RepViewProspectRowData[] {
  return rows.map((row) => ({
    address: row.restaurant_address,
    dateAddedAt: row.date_added_at,
    dateAddedDisplay: row.date_added_display,
    lastActivityAt: row.last_activity_at ?? undefined,
    lastActivityDisplay: row.last_activity_display ?? EMPTY_VALUE_PLACEHOLDER,
    name: row.restaurant_name,
    restaurantUUID: row.restaurant_id,
    supplierUUID: row.supplier_id,
    weeklyValueDisplay: formatWeeklyValue(
      row.weekly_estimated_value_in_micros,
      row.currency_code,
    ),
    weeklyValueInMicros: row.weekly_estimated_value_in_micros ?? undefined,
  }));
}
